import React from 'react';

import project1 from '../../assets/projects/construction-271873_1920.jpg';
import project2 from '../../assets/projects/architecture-1850092.jpg';
import project3 from '../../assets/projects/pexels-cmrcn-29224601.jpg';
import project4 from '../../assets/projects/construction-site-1477687_1280.jpg';
import project5 from '../../assets/projects/blueprint-964630_1280.jpg';
import project6 from '../../assets/projects/chairs-2181980.jpg';
import project7 from '../../assets/projects/construction-site-3871804_1920.jpg';
import project8 from '../../assets/projects/construction-7226875.jpg';
import project9 from '../../assets/projects/construction-site-6609637.jpg';

const projectImages = [
  { src: project1, title: 'Factory Development' },
  { src: project2, title: 'Modular Fabrication' },
  { src: project3, title: 'Containerized Structures' },
  { src: project4, title: 'Hospital Project' },
  { src: project5, title: 'Bulk Storage Terminal' },
  { src: project6, title: 'Roadway Construction' },
  { src: project7, title: 'Bridge Project' },
  { src: project8, title: 'Storage Facility' },
  { src: project9, title: 'Urban Site' },
];

const Projects = () => {
  return (
    <section className="w-full max-w-[1440px] mx-auto px-6 py-20">
      {/* Heading */}
      <div className="text-center mb-12">
        <p className="text-[#5bc0fe] text-[24px] font-semibold mb-2">Our Work Speaks</p>
        <h2 className="text-[#404040] text-[43px] font-black">Featured Projects</h2>
      </div>

      {/* Projects Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
        {projectImages.map((project, index) => (
          <div
            key={index}
            className="group relative overflow-hidden rounded-2xl shadow-xl border border-gray-200"
          >
            <img
              src={project.src}
              alt={project.title}
              loading="lazy"
              className="w-full h-[280px] object-cover transition-transform duration-500 ease-in-out group-hover:scale-110"
            />
            <div className="absolute inset-0 bg-black/50 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-500">
              <p className="text-white text-xl font-semibold">{project.title}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Projects;
